import React from "react";
import NavBar from "../../NavBar"
import Footer from "../../Footer"
import datiCover from "../../../data/telefonoProdotti.json";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from "react";
import ScrollabileRiga from "../ScrollabileRiga";
import Selezione from "../Selezione"

export default function Cover(){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function tornaSopra(){
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
    }
    useEffect(() => {
            window.addEventListener("scroll",(e)=>{
            const bottone = document.getElementById("btnTop");
            if(window.scrollY===0){
                try {
                    bottone.classList.add("invisibile");
                } catch (error) {
                    return null;
                }
                
                
                setTimeout(() => {
                    try {
                        bottone.classList.add("invisibilePerDavvero")
                    } catch (error) {
                        return null;
                    }
                    
                }, "490");
                try {
                    bottone.classList.remove("visibile");
                } catch (error) {
                    return null;
                }
                
            }else{
                try {
                    bottone.classList.remove("invisibile");
                    bottone.classList.remove("invisibilePerDavvero");
                    bottone.classList.add("visibile");
                } catch (error) {
                    return null;
                }
                
            }
            
        });
        
    });
    
    const arrId = ["Tipo C","Lightning","Micro USB","Caricatori","Adattatori"]    
    return (
        <div className="coverBody wuXieKeJi">
            <button id="btnTop" onClick={()=>tornaSopra()}><FontAwesomeIcon icon={faArrowUp} /></button>
            <NavBar uno ="Prodotti" due="Informazioni" tre="Contattaci" one="/prodotti" two="/informazioni" three="/contattaci"/>
            <h1 className="titoloProdotti">Carica Batterie e Adattatori</h1>
            <Selezione arr={arrId}/>
            
            <div className="colonna telefoni">

                <ScrollabileRiga idTitolo="TipoC" titolo="Tipo C" idScroll1="1" idScroll2="2" dati={datiCover} tipo="samsung" sottoTipo1="caricaBianco" sottoTipo2="caricaNero" nomeDati="telefonoProdotti"/>
                
                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Lightning" titolo="Lightning" idScroll1="3" idScroll2="4" dati={datiCover} tipo="cover" sottoTipo1="caricaBianco" sottoTipo2="caricaNero" nomeDati="telefonoProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="MicroUSB" titolo="Micro USB" idScroll1="5" idScroll2="6" dati={datiCover} tipo="samsungVecchio" sottoTipo1="caricaBianco" sottoTipo2="caricaNero" nomeDati="telefonoProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Caricatori" titolo="Caricatori" idScroll1="7" idScroll2="8" dati={datiCover} tipo="caricatori" sottoTipo1="caricaBianco" sottoTipo2="caricaNero" nomeDati="telefonoProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Adattatori" titolo="Adattatori" idScroll1="9" idScroll2="10" dati={datiCover} tipo="adattatori" sottoTipo1="add1" sottoTipo2="add2" nomeDati="telefonoProdotti"/>

            </div>
            <Footer />
        </div>
    )
}